import React from 'react'
import styles from '../styles'
import { arrowUp } from '../assets'

function GetStarted() {
  return (
    <div className={`${styles.flexCenter} w-[140px] h-[140px] rounded-full bg-blue-gradient p-[2px] cursor-pointer`}>
      <div className={`${styles.flexCenter} flex flex-col bg-primary w-[100%] h-[100%] rounded-full`}>
        <div className={`${styles.flexStart} flex-col`}>
          <div className={`${styles.flexStart} flex-row`}>
            <p className='font-poppins font-medium text-[18px] leading-[23px] text-start'>
              <span className='text-gradient'>Get</span>
            </p>
            <img src={arrowUp} className="w-[23px] h-[23px] object-contain ml-1" alt="arrow" />
          </div>
          <p className='font-poppins font-medium text-[18px] leading-[23px]'>
            <span className='text-gradient'>Started</span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default GetStarted